import ReviewIcon from 'Assets/icons/review.svg'
import { PanelHeader } from 'Components/common/TaskPanelHeader/TaskPanelHeader'
import { isEmpty } from 'lodash'
import styles from './Attributes.module.less'
import { ReactElement } from 'react'

export type AttributesPropsType = {
    getGroupElements: () => ReactElement[]
}

export const Attributes: React.FC<AttributesPropsType> = (props: AttributesPropsType) => {
    const groupElements = props.getGroupElements()
    if (isEmpty(groupElements)) {
        return null
    }

    return (
        <div className={styles['review-container']} data-testid="attributes-container">
            <PanelHeader title={'Supplementary Details'} actionButtons={[]} logo={ReviewIcon} />
            <div className={styles['review-body']}>
                {groupElements.map((element, index) => (
                    <div key={index}>{element}</div>
                ))}
            </div>
        </div>
    )
}
